import React from 'react';
import { ToolOutlined, LinkOutlined } from '@ant-design/icons';
import type { MenuDataItem } from '@ant-design/pro-components';

const authenticatedMenuData: MenuDataItem[] = [
    {
        path: '/tools',
        name: 'Tools',
        icon: <ToolOutlined />,
    },
    {
        path: '/connections',
        name: 'Connections',
        icon: <LinkOutlined />,
    },
];

export { authenticatedMenuData }; 